import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AssetAnalyticsDashboard from './pages/asset-analytics-dashboard';
import QuarterlyAuditWorkflow from './pages/quarterly-audit-workflow';
import AssetDetailManagement from './pages/asset-detail-management';
import SystemConfigurationPanel from './pages/system-configuration-panel';
import AssetManagementDashboard from './pages/asset-management-dashboard';
import UserManagementConsole from './pages/user-management-console';
import WarrantyManagementCenter from './pages/warranty-management-center';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AssetAnalyticsDashboard />} />
        <Route path="/asset-analytics-dashboard" element={<AssetAnalyticsDashboard />} />
        <Route path="/quarterly-audit-workflow" element={<QuarterlyAuditWorkflow />} />
        <Route path="/asset-detail-management" element={<AssetDetailManagement />} />
        <Route path="/system-configuration-panel" element={<SystemConfigurationPanel />} />
        <Route path="/asset-management-dashboard" element={<AssetManagementDashboard />} />
        <Route path="/user-management-console" element={<UserManagementConsole />} />
        <Route path="/warranty-management-center" element={<WarrantyManagementCenter />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
